import type {Job, QuestionStatus} from '@cp/model';
import {createCallable} from './createCallable';

export const jobCreateBulkChangeQuestionStatus = createCallable<
  {moduleId: string; filterStatus: QuestionStatus; changeStatus: QuestionStatus},
  Job
>('jobCreateBulkChangeQuestionStatus');

export const jobCreateQuestionGeneration = createCallable<
  {moduleId: string; topics: string[]; difficulties?: number[]; count?: number; runLimit?: number},
  Job
>('jobCreateQuestionGeneration');

export const jobCreateQuestionShuffle = createCallable<
  {moduleId: string; topics?: string[]; difficulties?: number[]; runLimit?: number},
  Job
>('jobCreateQuestionShuffle');

export const jobCreateQuestionValidation = createCallable<
  {moduleId: string; topics?: string[]; difficulties?: number[]; runLimit?: number},
  Job
>('jobCreateQuestionValidation');

export const jobCreateQuestionValidationGpt = createCallable<
  {moduleId: string; topics?: string[]; difficulties?: number[]; runLimit?: number},
  Job
>('jobCreateQuestionValidationGpt');

export const jobCreateSeedQuestionVariant = createCallable<
  {moduleId: string; seedQuestionCount: number; variantsPerSeed?: number; runLimit?: number},
  Job
>('jobCreateSeedQuestionVariant');

export const jobCreateStudyGeneration = createCallable<{moduleId: string; topics?: string[]; runLimit?: number}, Job>(
  'jobCreateStudyGeneration',
);

export const jobStart = createCallable('jobStart');
export const jobResume = createCallable('jobResume');
export const jobComplete = createCallable('jobComplete');
export const jobFail = createCallable('jobFail');
export const jobCancel = createCallable('jobCancel');
export const jobDelete = createCallable('jobDelete');
export const jobUpdateStatus = createCallable('jobUpdateStatus');
export const jobUpdateProgress = createCallable('jobUpdateProgress');
export const jobIncreaseRunLimit = createCallable('jobIncreaseRunLimit');
export const jobCleanupOld = createCallable('jobCleanupOld');
